export type CustomDomainStatus =
  | "pending"
  | "pending_validation"
  | "active"
  | "active_redeploying"
  | "moved"
  | "pending_blocked"
  | "pending_migration"
  | "pending_provisioned"
  | "provisioned"
  | "blocked"
  | null;

export type CustomDomainStep =
  | "connect"
  | "verification"
  | "disconnect"
  | "blocked"
  | null;

export function getCustomDomainEntry(
  isActive: boolean,
  domainStatus: CustomDomainStatus,
): CustomDomainStep {
  if (!isActive && domainStatus === null) return "connect";
  if (
    domainStatus === "pending" ||
    domainStatus === "pending_validation" ||
    domainStatus === "pending_migration" ||
    domainStatus === "pending_provisioned" ||
    domainStatus === "provisioned" ||
    domainStatus === "moved" ||
    domainStatus === "active_redeploying"
  ) {
    return "verification";
  }
  if (!isActive && domainStatus === "active") return "verification";
  if (isActive && domainStatus === "active") return "disconnect";
  if (domainStatus === "blocked" || domainStatus === "pending_blocked")
    return "blocked";
  return null;
}
